import React from "react";
import { Route, Redirect } from "react-router-dom";
import { storagePrefix } from "helpers";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
        localStorage.getItem(storagePrefix() + "user") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/signin", state: { from: props.location } }}
        />
      )
    }
  />
);
export * from "./PrivateRoute";
